import { z } from "zod/v4";

import { JSONValueSchema } from "../common";

import { ToolExecutionResultSchema } from "./tool-execution-result";

export const ToolResultSchema = z.object({
  success: z.boolean(),
  ts: z.number(),
  type: z.literal("tool-result"),
  toolCallId: z.string(),
  toolName: z.string(),
  input: z.record(z.string(), JSONValueSchema),
  output: ToolExecutionResultSchema,
});

export type ToolResult = z.infer<typeof ToolResultSchema>;
